import React, { Component } from 'react';
import './ueditor.less';

export default class UEditor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id ? this.props.id : null,
            content: this.props.content ? this.props.content : '',
            hasStyle: this.props.hasStyle ? {
                styleTitle: '素材库',
                styleShow: true,
                styleWidth: 360,
                stylePosition: 'right',
                appkey: 'aZVKgHvAw5',
            } : {}
        }
    }

    componentDidMount() {
        this.UEditorInit();
    }


    destroy() {
        this.ueditor = null
    }

    UEditorInit() {
        const { id, content } = this.state;
        if (!id) return;
        try {
            window.UE.delEditor(id);
        } catch (e) { }
        this.ueditor = window.UE.getEditor(id, this.state.hasStyle);
        this.ueditor.addListener('contentChange', () => {
            console.log('aaa')
            this.props.onChange(this.ueditor.getContent())
        })
        this.updateContent(content, () => {
            console.log('contentChange = ',content)
        })

    }
    updateContent(content, callback) {
        this.ueditor.ready(() => {
            console.log('callback', callback)
            this.ueditor.setContent(content);
            callback && callback()
        });
    }

    render() {
        let { id } = this.state;
        return (
            <textarea id={id} onChange={() => { }}></textarea>
        );
    }
}